import {
    GET_ALL_FAQS,
    GET_EDIT_DATA,
    GET_NEWSLETTER_CONTENT,
    GET_PRIVACY_POLICY_DATA,
    GET_TERM_DATA,
    GET_COKIE_POLICY_DATA,
    GET_HOW_IT_WORK_DATA,
    GET_ABOUT_DATA,
    GET_FAQ_DATA,
    GET_DPA_DATA,
    GET_RETURN_POLICY_DATA,
    GET_PRIVACY_POLICY_DATA_NL,
    GET_TERM_DATA_NL,
    GET_COKIE_POLICY_DATA_NL,
    GET_HOW_IT_WORK_DATA_NL,
    GET_ABOUT_DATA_NL,
    GET_DPA_DATA_NL,
    GET_RETURN_POLICY_DATA_NL,
    GET_FAQ_DATA_NL,
    GET_ALL_FAQS_NL,
    GET_NEWSLETTER_CONTENTNL,
    GET_HOME_CONTENTNL,
    GET_SELLERTERM_DATA,
    GET_BUYERTERM_DATA,
    GET_PROHIBITEDITEMS_DATA,
    GET_TRUSTSAFETY_DATA,
    GET_SELLERTERM_DATA_NL,
    GET_BUYERTERM_DATA_NL,
    GET_PROHIBITEDITEMS_DATA_NL,
    GET_TRUSTSAFETY_DATA_NL,
    GET_HOMEPAGE_HERO_SLIDES,
    GET_HOMEPAGE_HERO_SLIDES_NL,
    GET_CMS_DOCUMENTS,
    GET_CMS_DOCUMENT,
    GET_CMS_DOCUMENT_VERSIONS,
    GET_ARTICLES,
} from "./cmsTypes";


const initialState = {
    faqContent: null,
    faqItems: [],
    totalFaqs: 0,
    editData: null,
    newsletter_content: [],
    privacypolicydata: [],
    termdata: [],
    cookiepolicydata: [],
    howitworkdata: [],
    aboutusdata: [],
    dpadata: [],
    returnpolicydata: [],
    sellertermdata: [],
    buyertermdata: [],
    prohibiteditems: [],
    trustsafetydata: [],

    privacypolicydatanl: [],
    termdatanl: [],
    cookiepolicydatanl: [],
    howitworkdatanl: [],
    aboutusdatanl: [],
    dpadatanl: [],
    returnpolicydatanl: [],
    faqContentnl: null,
    faqItemsnl: [],
    newsletter_content_nl: [],
    home_content_nl: [],
    sellertermdatanl:[],
    buyertermdatanl:[],
    prohibiteditemsnl: [],
    trustsafetydatanl:[],
    homepageHeroSlides: null,
    homepageHeroSlidesNl: null,
    cmsDocuments: [],
    totalCmsDocuments: 0,
    cmsDocument: null,
    cmsDocumentVersions: [],
    articles: [],
    totalArticles: 0,
};

const cmsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CMS_DOCUMENTS:
            return {
                ...state,
                cmsDocuments: action.payload.documents,
                totalCmsDocuments: action.payload.total,
            };
        case GET_ARTICLES:
            return {
                ...state,
                articles: action.payload.data,
                totalArticles: action.payload.pagination.total,
            };
        case GET_CMS_DOCUMENT:
            return {
                ...state,
                cmsDocument: action.payload,
            };
        case GET_CMS_DOCUMENT_VERSIONS:
            return {
                ...state,
                cmsDocumentVersions: action.payload,
            };
        case GET_HOMEPAGE_HERO_SLIDES:
            return { ...state, homepageHeroSlides: action.payload };
        case GET_HOMEPAGE_HERO_SLIDES_NL:
            return { ...state, homepageHeroSlidesNl: action.payload };
        case GET_EDIT_DATA:
            return {
                ...state,
                editData: action.payload,
            };
        case GET_NEWSLETTER_CONTENT:
            return {
                ...state,
                newsletter_content: action.payload,
            };
        case GET_NEWSLETTER_CONTENTNL:
            return {
                ...state,
                newsletter_content_nl: action.payload,
            };
        case GET_PRIVACY_POLICY_DATA:
            return {
                ...state,
                privacypolicydata: action.payload,
            };

        case GET_PRIVACY_POLICY_DATA_NL:
            return {
                ...state,
                privacypolicydatanl: action.payload,
            };

        case GET_TERM_DATA:
            return {
                ...state,
                termdata: action.payload,
            };
        case GET_TERM_DATA_NL:
            return {
                ...state,
                termdatanl: action.payload,
            };

        case GET_COKIE_POLICY_DATA:
            return {
                ...state,
                cookiepolicydata: action.payload,
            };
        case GET_COKIE_POLICY_DATA_NL:
            return {
                ...state,
                cookiepolicydatanl: action.payload,
            };
        case GET_HOME_CONTENTNL:
            return {
                ...state,
                home_content_nl: action.payload,
            };
        case GET_HOW_IT_WORK_DATA:
            return {
                ...state,
                howitworkdata: action.payload,
            };
        case GET_HOW_IT_WORK_DATA_NL:
            return {
                ...state,
                howitworkdatanl: action.payload,
            };
        case GET_ABOUT_DATA:
            return {
                ...state,
                aboutusdata: action.payload,
            };
        case GET_ABOUT_DATA_NL:
            return {
                ...state,
                aboutusdatanl: action.payload,
            };

        case GET_DPA_DATA:
            return {
                ...state,
                dpadata: action.payload,
            };
        case GET_DPA_DATA_NL:
            return {
                ...state,
                dpadatanl: action.payload,
            };
        case GET_RETURN_POLICY_DATA:
            return {
                ...state,
                returnpolicydata: action.payload,
            };
        case GET_RETURN_POLICY_DATA_NL:
            return {
                ...state,
                returnpolicydatanl: action.payload,
            };
        case GET_FAQ_DATA:
            return {
                ...state,
                faqContent: action.payload,
            };
        case GET_ALL_FAQS:
            return {
                ...state,
                faqItems: action.payload,
            };
        case GET_FAQ_DATA_NL:
            return {
                ...state,
                faqContentnl: action.payload,
            };
        case GET_ALL_FAQS_NL:
            return {
                ...state,
                faqItemsnl: action.payload,
            };

        case GET_SELLERTERM_DATA:
            return {
                ...state,
                sellertermdata: action.payload,
            };
        case GET_BUYERTERM_DATA:
            return {
                ...state,
                buyertermdata: action.payload,
            };
        case GET_PROHIBITEDITEMS_DATA:
            return {
                ...state,
                prohibiteditems: action.payload,
            };
        case GET_TRUSTSAFETY_DATA:
            return {
                ...state,
                trustsafetydata: action.payload,
            };
             case GET_SELLERTERM_DATA_NL:
            return {
                ...state,
                sellertermdatanl: action.payload,
            };
            case GET_BUYERTERM_DATA_NL:
            return {
                ...state,
                buyertermdatanl: action.payload,
            };
            case GET_PROHIBITEDITEMS_DATA_NL:
            return {
                ...state,
                prohibiteditemsnl: action.payload,
            };
            case GET_TRUSTSAFETY_DATA_NL:
            return {
                ...state,
                trustsafetydatanl: action.payload,
            };


            
        default:
            return state;
    }
};

export default cmsReducer;
